import { container } from './container';
/**
 *  判断是否function
 * @param {*} fn 
 * @returns 
 */
function isFunction (fn) {
  return typeof fn === 'function';
}
/**
 * 代理方法
 * @param {*} instanceName  实例名称
 * @param {*} fn  方法
 * @param {*} beforeAction  执行前操作
 * @param {*} afterAction 执行后操作
 * @returns 
 */
function proxyMethod (fn, beforeAction, afterAction) {
  return function (...args) {
    const context = this;
    const id = this._generateId();
    if (isFunction(beforeAction)) {
      beforeAction.apply(context, [id, args]);
    }
    const result = fn.apply(context, args);
    if (isFunction(afterAction)) {
      afterAction.apply(context, [id, args, result]);
    }
  };
}


/**
 * 动作装饰器
 * @param {string}  
 * @returns 
 */
function actionInterceptor (beforeAction, afterAction) {
  return function (opts = {}) {
    return function (target, name, descriptor) {
      const fn = descriptor.value;
      const methodName = opts.methodName || name;
      if (!isFunction(beforeAction)) {
        beforeAction = () => false;
      }
      if (!isFunction(afterAction)) {
        afterAction = () => false;
      }
      descriptor.value = proxyMethod(fn, beforeAction(methodName), afterAction(methodName));
      descriptor.value.execTime = opts.execTime || 0;
    };
  };
}



function staticIdDecorator (id) {
  return generateIdDecorator(function () {
    return id;
  });
}
/**
 * 生成实例标识装饰器
 * @param {*} fn 
 * @returns 
 */
function generateIdDecorator (fn) {
  return function (target) {
    return class subClass extends target {
      constructor (...args) {
        super(...args);
        container.add(this._generateId(), this);
      }
      _generateId () {
        return fn.bind(this)();
      }
    };
  };
}


/**
 * 生成实例标识装饰器
 * @param {*} fn 
 * @returns 
 */
function staticIdProxy (fn, id) {
  return generateIdProxy(fn, function () {
    return id;
  });
}


/**
 * 生成实例标识装饰器
 * @param {*} fn 
 * @returns 
 */
function generateIdProxy (fn, generateIdfn) {
  return function (...args) {
    let context = this;
    const result = fn.apply(context, args);
    context._generateId = generateIdfn;
    container.add(this._generateId(), context);
    return result;
  };
}


/**
 * 拦截处理器
 */
class HandlerInterceptor {
  constructor (name) {
    this.name = name;
    container.add(name, this);
  }
  preHandle () {
    return;
  }
  postHandle () {
    return;
  }
  dispose () {
    container.remove(this.name);
  }
}
export {
  proxyMethod,
  actionInterceptor,
  generateIdProxy,
  staticIdProxy,
  generateIdDecorator,
  staticIdDecorator,
  HandlerInterceptor
};